import { render, staticRenderFns } from "./LeVue.vue?vue&type=template&id=9c63d518&scoped=true&"
import script from "./LeVue.vue?vue&type=script&lang=js&"
export * from "./LeVue.vue?vue&type=script&lang=js&"
import style0 from "./LeVue.vue?vue&type=style&index=0&id=9c63d518&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c63d518",
  null
  
)

export default component.exports